module.exports = __webpack_public_path__ + "img/leecv.8977d1f8.png";